import React from 'react';
import { Alert, Box, Theme } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ProfileAttributes } from '@loyalty/shared-common/profile-api-client';
import { colorPalette } from '@qualifio/ui-commons';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { UnblockMemberConfirm } from './BlockAndUnblockMemberButtons';

const useStyles = makeStyles<Theme>(({ spacing }) => ({
  root: {
    marginBottom: spacing(3),
    display: 'flex',
  },
  unblockLink: {
    color: colorPalette.blue.main,
    textDecoration: 'underline',
    cursor: 'pointer',
    marginLeft: spacing(0.5),
  },
  loader: {
    marginLeft: spacing(0.5),
  },
}));

export interface MemberBlockedAlertProps {
  profile: ProfileAttributes;
  programId: string;
  onUnblock?: () => Promise<void> | void;
}

export function MemberBlockedAlert(props: MemberBlockedAlertProps) {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Alert className={classes.root} severity="error">
      <Box sx={{ display: 'flex' }}>
        <span>{t('profiles.actions.block.alert.message')}</span>
        <UnblockMemberConfirm
          {...props}
          childFactory={(loading, disabled, onConfirm) => (
            <a
              className={classes.unblockLink}
              onClick={() => {
                if (!disabled) {
                  onConfirm();
                }
              }}
            >
              {t('profiles.actions.block.alert.action')}
              {loading && <FontAwesomeIcon icon={faSpinner} spin className={classes.loader} />}
            </a>
          )}
        />
      </Box>
    </Alert>
  );
}
